import { render } from "./TheSheetUsedUpper.vue?vue&type=template&id=4a8fcbda"
import script from "./TheSheetUsedUpper.vue?vue&type=script&lang=js"
export * from "./TheSheetUsedUpper.vue?vue&type=script&lang=js"
script.render = render

export default script